import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
})
  .then(() => {
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('ng-version');
    }
  })
  .catch((err) => console.error(err));
